import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';

const WvarGraph = ({ percentageData }) => {
  const [percentage, setPercentage] = useState(0);

  useEffect(() => {
    if (percentageData) {
      setPercentage(percentageData.wVar);
    }
  }, [percentageData]);

  const options = {
    chart: {
      height: 300,
      type: 'radialBar',
      animations: {
        enabled: true,
        easing: 'easeinout',
        speed: 800,
      },
      dropShadow: {
        enabled: true,
        top: 2,
        left: 2,
        blur: 1,
        opacity: 0.2,
      },
    },
    plotOptions: {
      radialBar: {
        hollow: {
          size: '60%',
          
        },
        track: {
          background: '#FFE4EB', // Darker shade for the underside of the outer circle
          strokeWidth: '100%',
          opacity: 1,
          margin: 5, // margin is in pixels
          dropShadow: {
            enabled: true,
            top: 5,
            left: 5,
            blur: 8,
            opacity: 0.7,
            color: '#894053',

          },
        },
        dataLabels: {
          name: {
            offsetY: -10,
            show: false,
            color: '#757FD5',
            fontSize: '14px',
            fontWeight: 'bold',
          },
          value: {
            offsetY: 5,
            fontSize: '24px',
            color: '#A14A60',
            fontWeight: 'bold',
            formatter: (val) => `${val}%`,
          },
        },
      },
    },
    fill: {
      type: 'solid',
      
      colors: ['#C56B82'],
    },
    stroke: {
      lineCap: 'round',
    },
    // labels: ['Incoming Moisture'],
  };

  const series = [percentage];

  return (
    <div>
        <h3 className="text-xl font-semibold lg:text-xl mb-2 text-[#A14A60]" >Water Variance</h3>
      <ReactApexChart options={options} series={series} type="radialBar" height={300} />
    </div>
  );
};

export default WvarGraph;